import { render, staticRenderFns } from "./AIChatComponent.vue?vue&type=template&id=3d457ac4&scoped=true"
import script from "./AIChatComponent.vue?vue&type=script&lang=js"
export * from "./AIChatComponent.vue?vue&type=script&lang=js"
import style0 from "./AIChatComponent.vue?vue&type=style&index=0&id=3d457ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d457ac4",
  null
  
)

export default component.exports